<div class="flex flex-column h-full">
  <div class="flex justify-content-end mb-2">
    <app-prime-ng-export-table [primeNgList]="this"></app-prime-ng-export-table>
    <button
      pButton
      pRipple
      type="button"
      icon="pi pi-table"
      label="{{ 'FORM.SHOW-HIDE-COLUMNS' | translate }}"
      class="p-button-success me-3 position-relative"
      (click)="openColumnSidebar()"
    ></button>
  </div>
  <div class="flex-grow overflow-hidden h-full">
    <p-table
      [columns]="columns"
      [dataKey]="keys.primary_key"
      [value]="rows"
      [loading]="loading"
      [paginator]="true"
      [rows]="rowsPerPage"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      styleClass="p-datatable-gridlines"
      [(selection)]="selectedRows"
      [scrollable]="true"
      scrollHeight="flex"
      [resizableColumns]="true"
      [currentPageReportTemplate]="
        'GENERAL.SHOWING-X-TO-Y-OF-Z-ROWS'
          | translate
            : {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
              }
      "
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3rem" pFrozenColumn>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <ng-container *ngFor="let col of columns">
            <th
              [pSortableColumn]="col.sortable"
              pFrozenColumn
              [frozen]="col.frozen"
              pResizableColumn
              [pResizableColumnDisabled]="!col.resizable"
              [width]="col.width"
              [style.minWidth.px]="col.resizable ? 0 : col.width"
              *ngIf="col.visible"
            >
              <div class="flex align-items-center gap-2">
                {{ col.header | translate }}
                <p-sortIcon
                  *ngIf="col.sortable"
                  [field]="col.sortable"
                ></p-sortIcon>
                <p-columnFilter
                  *ngIf="col.filterable"
                  type="text"
                  [field]="col.sortable"
                  display="menu"
                ></p-columnFilter>
              </div>
            </th>
          </ng-container>
          <th [width]="150" alignFrozen="right" pFrozenColumn></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <td pFrozenColumn>
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let col of columns">
            <td
              pFrozenColumn
              [frozen]="col.frozen"
              [width]="col.width"
              *ngIf="col.visible"
            >
              <div style="white-space: pre-line">
                {{ col.field | ngCellValue : row }}
              </div>
            </td>
          </ng-container>
          <td [width]="150" class="p-2" alignFrozen="right" pFrozenColumn>
            <div
              class="flex flex-grow-1 justify-content-center md:justify-content-end mt-2 md:mt-0 gap-2"
            >
              <button
                pButton
                pRipple
                icon="pi pi-book"
                pTooltip="{{ 'FORM.RESPONSABLE-WARRIOR' | translate }}"
                (click)="openDialogResponsables(row)"
                class="p-button-text p-button-raised p-button-success"
              ></button>
              <button
                pButton
                pRipple
                icon="pi pi-pencil"
                pTooltip="{{ 'ENV.EDIT' | translate }}"
                routerLink="/configuration/wall/edit/{{ row.wall_id }}"
                class="p-button-text p-button-raised"
              ></button>
              <button
                pButton
                pRipple
                icon="pi pi-trash"
                pTooltip="{{ 'ENV.DELETE' | translate }}"
                (click)="inactivate(row)"
                class="p-button-text p-button-raised p-button-danger"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">{{ "WIDGET.DT-EMPTY" | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar
  [(visible)]="isColumnToggleVisible"
  position="right"
  [baseZIndex]="10000"
  [style]="{ width: '100%', 'max-width': '20em' }"
>
  <app-prime-list-columns-toggle
    [(columns)]="columns"
  ></app-prime-list-columns-toggle>
</p-sidebar>

<p-dialog
  [(visible)]="isReponsableWarriorVisible"
  [modal]="true"
  [style]="{ width: '95%', height: '95%' }"
  [draggable]="false"
  [resizable]="false"
  [contentStyle]="{ height: '100%' }"
>
  <ng-template pTemplate="header">
    <div class="w-full flex justify-content-between">
      <h3>
        {{ "FORM.RESPONSABLE-WARRIOR" | translate }} | {{ itemSelected?.name_ }}
      </h3>
      <button
        pButton
        pRipple
        type="button"
        label="{{ 'ENV.SAVE' | translate }}"
        styleClass="p-button-success"
        (click)="onSaveResponsable()"
      ></button>
    </div>
  </ng-template>
  <div class="flex w-full row">

    <div class="col-6 flex flex-column gap-2 my-4">
      <span class="p-float-label">
        <p-dropdown
          #dd
          id="dni-type"
          name="dni-type"
          [options]="data.sources['user_available'].data"
          [(ngModel)]="userSelected"
          placeholder="{{ 'FORM.SELECT-A-M' | translate }} {{
            ('MENU.USERS-WALL' | translate).toLowerCase()
          }}"
          [filter]="true"
          appendTo="body"
          class="w-full"
          styleClass="w-full"
          (onChange)="onSelectUser(dd.selectedOption)"
          [optionLabel]="data.sources['user_available'].label"
          [optionValue]="data.sources['user_available'].key"
        >
        </p-dropdown>
        <label for="users">{{ "MENU.USERS-WALL" | translate }}</label>

      </span>
    </div>
  </div>

  <div class="flex w-full row flex-column">
    <div
      class="card-list-item col-12 flex row mx-0 align-items-center"
      *ngFor="let item of form.users; let i = index"
    >
      <div class="card-item-title col-2">
        {{ item.full_name }}
      </div>

      <div class="col-4 flex flex-column gap-2">
        <span class="p-float-label">
          <p-multiSelect
            [id]="'state-' + i"
            [name]="'state-' + i"
            [options]="item.sourceStates"
            [(ngModel)]="item.states"
            [filter]="true"
            [optionValue]="data.sources['states'].key"
            [optionLabel]="data.sources['states'].label"
            (ngModelChange)="filterByState(item)"
            placeholder="{{ 'FORM.SELECT-A-M' | translate }} {{
              ('MENU.STATES' | translate).toLowerCase()
            }}"
            [required]="true"
          ></p-multiSelect>
          <label for="topics">{{ "MENU.STATES" | translate }}</label>
        </span>
      </div>

      <div class="col-4 flex flex-column gap-2">
        <span class="p-float-label">
          <p-multiSelect
            [id]="'city-' + i"
            [name]="'city-' + i"
            [options]="item.sourceCities"
            [(ngModel)]="item.cities"
            [filter]="true"
            [optionValue]="data.sources['city'].key"
            [optionLabel]="data.sources['city'].label"
            placeholder="{{ 'FORM.SELECT-A-M-F' | translate }} {{
              ('MENU.CITIES' | translate).toLowerCase()
            }}"
            [required]="true"
          ></p-multiSelect>
          <label for="topics">{{ "MENU.CITIES" | translate }}</label>
        </span>
      </div>

      <div class="col-2" style="display: flex; justify-content: end">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-trash"
          (click)="removeUser(item)"
          class="p-button-text p-button-danger"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>
